import { Section } from './Section.js';

const LAYERS = [
  {
    number: '01',
    name: 'Prospect Graph',
    kicker: 'Public signals, resolved into a company record.',
    body: 'Public business profiles, ad-library activity, posting cadence, reply latency, tone of voice, and whether chat automation is already in place. Every field carries the source it came from and the date it was read, so a record can be argued with rather than trusted.',
  },
  {
    number: '02',
    name: 'Fit Engine',
    kicker: 'Scoring that predicts lift, not luck.',
    body: 'Semantic match against the offer, tabular scoring over firmographic and behavioural features, and an uplift model that predicts the increase in reply probability caused by the touch rather than raw propensity. Niche discovery runs on the same features, surfacing segments that respond rather than segments that merely exist.',
  },
  {
    number: '03',
    name: 'Envoy Runtime',
    kicker: 'A conversation that can be stopped mid-sentence.',
    body: 'A tool-calling agent with persistent conversation state and a hard policy layer that sits after generation: it can block a message the model has already produced. Channel rules, messaging windows, opt-in status and disclosure requirements are enforced by the runtime, not by the prompt.',
  },
];

export function ProductSection() {
  return (
    <Section
      id="product"
      label="Product"
      title={
        <>
          Three layers on
          <br className="hidden sm:block" /> one data loop
        </>
      }
      intro="Each layer writes back into the same store the next one reads. Enrichment feeds scoring, scoring picks the segment, the agent's outcomes retrain the score. Nothing is a black box that only reports success."
    >
      <div className="divide-y divide-hairline border-t border-hairline">
        {LAYERS.map((layer) => (
          <div key={layer.number} className="grid md:grid-cols-12 gap-3 md:gap-8 py-8 sm:py-10">
            <div className="md:col-span-4">
              <div className="flex items-baseline">
                <span className="text-sm text-ink/40 tabular">{layer.number}</span>
                <span className="mx-2 text-sm text-ink/30">/</span>
                <span className="text-sm font-medium text-ink">{layer.name}</span>
              </div>
              <div className="mt-2 text-sm text-ink/50 leading-relaxed">{layer.kicker}</div>
            </div>
            <div className="md:col-span-8">
              <p className="text-sm md:text-[15px] text-ink/70 leading-relaxed">{layer.body}</p>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
}

export default ProductSection;
